import societyIndex from '@/views/society/societyIndex.vue'
import applyIndex from '@/views/society/apply/index.vue'
import authenticationIndex from '@/views/society/authentication/index.vue'
import retirementIndex from '@/views/society/retirement/index.vue'
import queryIndex from '@/views/society/query/index.vue'
import residentIndex from '@/views/society/resident/index.vue'
import temporaryIndex from '@/views/society/temporary/index.vue'

export default {
  path: '/society',
  component: {
    render (c) { return c('router-view') }
  },
  children: [
    {
      path: 'societyIndex',
      name: 'societyIndex',
      component: societyIndex
    },
    // 电子社保卡申领页面
    {
      path: 'apply/index',
      name: 'applyIndex',
      component: applyIndex
    },
    // 养老待遇资格认证页面
    {
      path: 'authentication/index',
      name: 'authenticationIndex',
      component: authenticationIndex
    },
    // 城乡居民养老保险待遇申请页面
    {
      path: 'retirement/index',
      name: 'retirementIndex',
      component: retirementIndex
    },
    // 养老保险待遇发放明细查询页面
    {
      path: 'query/index',
      name: 'queryIndex',
      component: queryIndex
    },
    // 城乡居民养老保险缴费页面
    {
      path: 'resident/index',
      name: 'residentIndex',
      component: residentIndex
    },
    // 社保卡临时挂失页面
    {
      path: 'temporary/index',
      name: 'temporaryIndex',
      component: temporaryIndex
    }

  ]
}
